import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

// [pageHeader]
vuwer.add("pageHeader", {
	className: "page-header",
	
	selector() {
		return  $("<header/>").addClass(this.className).insertAfter(
			vuwer.get("appHeader").$self
		);
	},
	
	onReadyFirst($self) {
		const $content = $("<div/>").addClass("content").appendTo($self);
		this.$title = $("<h1/>").addClass("title").appendTo($content);
	},
	
	async onChangeState(state) {
		const methods = [];
		
		if( u_.hasProperty(state, "ttl") ) {
			methods.push( this.get("pageTtl").setState("txt", state.ttl) );
		}
		
		if( u_.hasProperty(state, "subttl") ) {
			methods.push( this.get("pageSubttl").setState("txt", state.subttl) );
		}
		
		return !methods.length || Promise.all(methods);
	}
}, function() {
	// [add child Vuw]
	this
	// [pageTtl]
	.add("pageTtl", {
		selector() {
			return $("<span/>").appendTo(
				this.container.$title
			);
		},
		
		onChangeState(state) {
			if(this.$self && state.txt !== this.state.txt) {
				this.$self.text(state.txt);
			}
		}
	})
	
	// [pageSubttl]
	.add("pageSubttl", {
		selector() {
			return $("<span/>").addClass("sub").appendTo(
				this.container.$title
			);
		},
		
		onChangeState(state) {
			if(this.$self && state.txt !== this.state.txt) {
				this.$self.text(state.txt);
			}
		}
	});
});
